"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _activityZone = require("@/api/basic/activityZone");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'activityOne',
  components: {
    SwPage: _SwPage.default
  },
  data: function data() {
    return {
      uploadAction: '#',
      listLoading: true,
      activityList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        title: null
      },
      showAdvanced: false,
      dialog: {
        status: 'create',
        visible: false
      },
      formData: {
        title: '',
        description: '',
        imageUrl: '',
        type: null,
        linkType: null,
        linkValue: '',
        sortOrder: 0,
        enabled: 1,
        isVip: 6,
        vipLevelStr: '',
        isAddedWecom: 6,
        hasOrdered: 6,
        isNewCouponExpired: 6,
        startTime: '',
        endTime: ''
      },
      vipLevelStrList: [],
      checkboxRenderKey: 0,
      uploadFileList: [],
      previewDialog: {
        visible: false,
        url: ''
      },
      uploadDialog: {
        visible: false,
        row: null,
        fileList: []
      },
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        // description: [{ required: true, message: '请输入说明', trigger: 'blur' }],
        imageUrl: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择活动类型',
          trigger: 'blur'
        }],
        linkType: [{
          required: true,
          message: '请选择跳转类型',
          trigger: 'blur'
        }],
        linkValue: [{
          required: true,
          message: '请输入跳转路径',
          trigger: 'blur'
        }],
        sortOrder: [{
          required: true,
          message: '请输入排序值',
          trigger: 'blur'
        }],
        enabled: [{
          required: true,
          message: '请选择启用状态',
          trigger: 'blur'
        }],
        isVip: [{
          required: true,
          message: '请选择是否会员',
          trigger: 'blur'
        }],
        vipLevelStr: [{
          required: true,
          message: '请选择会员等级',
          trigger: 'blur'
        }],
        isAddedWecom: [{
          required: true,
          message: '请选择是否添加企微',
          trigger: 'blur'
        }],
        hasOrdered: [{
          required: true,
          message: '请选择是否下过单',
          trigger: 'blur'
        }],
        isNewCouponExpired: [{
          required: true,
          message: '请选择新人券是否过期',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择生效开始时间',
          trigger: 'blur'
        }],
        endTime: [{
          required: true,
          message: '请选择生效截止时间',
          trigger: 'blur'
        }]
      },
      resPath: process.env.VUE_APP_IMAGE_PATH
    };
  },
  created: function created() {
    this.getList();
    this.getResPathInfo();
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(date) {
          if (!_this.formData.endTime) return false;
          return date.getTime() > new Date(_this.formData.endTime).getTime();
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this2 = this;
      return {
        disabledDate: function disabledDate(date) {
          if (!_this2.formData.startTime) return false;
          return date.getTime() < new Date(_this2.formData.startTime).getTime();
        }
      };
    },
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 258, "px");
    }
  },
  methods: {
    initVipLevelStrList: function initVipLevelStrList() {
      this.checkboxRenderKey++;
    },
    getResPathInfo: function getResPathInfo() {
      var _this3 = this;
      (0, _upgradeStrategy.getResPath)().then(function (res) {
        _this3.resPath = res.data;
      });
    },
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _activityZone.getActivityPage)(this.listQuery).then(function (res) {
        _this4.activityList = res.records;
        _this4.total = res.total;
        setTimeout(function () {
          _this4.listLoading = false;
        }, 300);
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    toggleAdvanced: function toggleAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleCreate: function handleCreate() {
      this.dialog.status = 'create';
      this.dialog.visible = true;
      this.formData = {};
      this.uploadFileList = [];
    },
    handleUpdate: function handleUpdate(row) {
      var _this5 = this;
      (0, _activityZone.getActivityDetail)(row.id).then(function (res) {
        _this5.formData = res.data;
        // 会员等级回显
        if (_this5.formData.vipLevelStr) {
          _this5.vipLevelStrList = _this5.formData.vipLevelStr.split(',').map(String);
        } else {
          _this5.vipLevelStrList = [];
        }
        _this5.dialog.status = 'update';
        _this5.dialog.visible = true;
        if (_this5.formData.imageUrl) {
          _this5.uploadFileList = [{
            name: '活动图',
            url: _this5.resPath + _this5.formData.imageUrl
          }];
        } else {
          _this5.uploadFileList = [];
        }
      });
    },
    handleStatusChange: function handleStatusChange(id, status) {
      var _this6 = this;
      (0, _activityZone.updateActivityStatus)({
        id: id,
        enabled: status
      }).then(function () {
        _this6.$message.success('状态更新成功');
        _this6.getList();
      }).catch(function () {
        _this6.$message.error('状态更新失败');
        _this6.getList();
      });
    },
    handleDelete: function handleDelete(row) {
      var _this7 = this;
      this.$confirm('确认删除该活动？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _activityZone.deleteActivity)(row.id).then(function () {
          _this7.$message.success('删除成功');
          _this7.getList();
        });
      });
    },
    handleDrawerClose: function handleDrawerClose() {
      var _this8 = this;
      this.dialog.visible = false;
      this.formData = {};
      this.uploadFileList = [];
      this.$nextTick(function () {
        return _this8.$refs.form.clearValidate();
      });
    },
    submitForm: function submitForm() {
      var _this9 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this9.formData.isVip === 1 && Array.isArray(_this9.vipLevelStrList)) {
          _this9.formData.vipLevelStr = _this9.vipLevelStrList.join(',');
        } else {
          _this9.formData.vipLevelStr = '';
        }
        var api = _this9.dialog.status === 'create' ? _activityZone.createActivity : _activityZone.updateActivity;
        api(_this9.formData).then(function () {
          _this9.$message.success(_this9.dialog.status === 'create' ? '创建成功' : '更新成功');
          _this9.handleDrawerClose();
          _this9.getList();
        });
      });
    },
    handleUploadDialog: function handleUploadDialog(row) {
      this.uploadDialog.row = row;
      this.uploadDialog.visible = true;
      this.uploadDialog.fileList = [];
    },
    handleCustomUpload: function handleCustomUpload(_ref) {
      var _this0 = this;
      var file = _ref.file;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.uploadDialog.row.id);
      (0, _activityZone.uploadActivityImageSeparate)(formData).then(function () {
        _this0.$message.success('上传成功');
        _this0.uploadDialog.visible = false;
        _this0.getList();
      }).catch(function () {
        _this0.$message.error('上传失败');
        _this0.uploadDialog.visible = false;
      });
    },
    handleFileChange: function handleFileChange(file) {
      this.uploadDialog.fileList = [file];
    },
    removeFile: function removeFile() {
      this.uploadDialog.fileList = [];
    },
    resetUpload: function resetUpload() {
      this.uploadDialog.visible = false;
      this.uploadDialog.row = null;
      this.uploadDialog.fileList = [];
    },
    handlePictureUpload: function handlePictureUpload(_ref2) {
      var _this1 = this;
      var file = _ref2.file;
      var formData = new FormData();
      formData.append('file', file);
      (0, _activityZone.uploadActivityImage)(formData).then(function (res) {
        var url = res.data;
        _this1.formData.imageUrl = url;
        _this1.uploadFileList = [{
          name: '活动图',
          url: _this1.resPath + url
        }];
        _this1.$message.success('上传成功');
      }).catch(function () {
        _this1.$message.error('上传失败');
      });
    },
    handleRemoveFile: function handleRemoveFile() {
      this.uploadFileList = [];
      this.formData.imageUrl = '';
    },
    handlePreview: function handlePreview(file) {
      this.previewDialog.url = file.url;
      this.previewDialog.visible = true;
    },
    getVipLevelNames: function getVipLevelNames(vipLevelStr) {
      if (!vipLevelStr) return '';
      var map = {
        '1': '普卡',
        '2': '银卡',
        '3': '金卡',
        '4': '黑金卡',
        '5': '钻石卡'
      };
      return vipLevelStr.split(',').map(function (val) {
        return map[val] || val;
      }).join('，');
    }
  }
};